class UserAgent {

    isMaxWidth(width = 0) {
        return window.innerWidth < width;
    } 

    isMobileResolution(mobileSize = 525) {
        return window.innerWidth <= mobileSize;
    } 

    devicePixelRatio() {
        return window.devicePixelRatio || 1;
    }

    isEcosystemApple() {
        return (window.safari || window.navigator.userAgent.match(/(iPad|iPhone|iPod)/i) || window.navigator.userAgent.match(/iPhone/i)) && navigator.userAgent.match(/AppleWebKit/);
    }
}

const userAgent = new UserAgent();

export default userAgent;


// WEBPACK FOOTER //
// ./src/core/helpers/userAgent.js